import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FormSection, Field } from "@/components/dossiers/FormSection";
import MicButton from "@/components/ui/MicButton";
import { CONTEXTES_AUDIT } from "@/lib/checklist";
import { YEARS } from "@/lib/dataroom";
import DocumentChecklistEditor from "@/components/dossiers/DocumentChecklistEditor";

export function rangeYears(debut, fin) {
    if (!debut || !fin) return [];
    const a = Math.min(debut, fin), b = Math.max(debut, fin);
    return Array.from({ length: b - a + 1 }, (_, i) => a + i);
}

export default function MissionSection({ nomMission, setNomMission, notes, setNotes, exercice, setExercice, contexte, setContexte, contexteAutre, setContexteAutre, documentsRequis, setDocumentsRequis }) {

    return (
        <FormSection step={3} title="Mission" description="Nommez la mission, indiquez le contexte de la mission (il conditionne les pièces attendues en dataroom) et les exercices à analyser." testId="mission-section">
            <Field id="nom-mission" label="Nom de la mission" required>
                <Input id="nom-mission" data-testid="nom-mission-input" className="h-11 bg-card max-w-md" placeholder="ex. Audit Restructuration 2026" maxLength={160} value={nomMission} onChange={(e) => setNomMission(e.target.value)} />
            </Field>

            <Field id="contexte-audit" label="Contexte de la mission" required>
                <Select value={contexte} onValueChange={setContexte}>
                    <SelectTrigger id="contexte-audit" data-testid="contexte-audit-select" className="h-11 bg-card max-w-md"><SelectValue placeholder="Sélectionner le contexte…" /></SelectTrigger>
                    <SelectContent>{CONTEXTES_AUDIT.map((c) => <SelectItem key={c.value} value={c.value} data-testid={`contexte-audit-${c.value}`}>{c.label}</SelectItem>)}</SelectContent>
                </Select>
                {contexte === "autre" && (
                    <Input data-testid="contexte-autre-input" className="h-11 bg-card max-w-md mt-2" placeholder="Précisez le contexte (ex. litige entre associés, audit d'acquisition partiel…)" maxLength={200} value={contexteAutre} onChange={(e) => setContexteAutre(e.target.value)} />
                )}
            </Field>

            <div className="grid grid-cols-2 gap-5 max-w-md">
                <Field id="exercice-debut" label="Premier exercice">
                    <Select value={exercice.debut ? String(exercice.debut) : ""} onValueChange={(v) => setExercice((e) => ({ ...e, debut: Number(v) }))}>
                        <SelectTrigger id="exercice-debut" data-testid="exercice-debut-select" className="h-11 bg-card"><SelectValue placeholder="Année" /></SelectTrigger>
                        <SelectContent>{YEARS.map((y) => <SelectItem key={y} value={String(y)} data-testid={`exercice-debut-${y}`}>{y}</SelectItem>)}</SelectContent>
                    </Select>
                </Field>
                <Field id="exercice-fin" label="Dernier exercice">
                    <Select value={exercice.fin ? String(exercice.fin) : ""} onValueChange={(v) => setExercice((e) => ({ ...e, fin: Number(v) }))}>
                        <SelectTrigger id="exercice-fin" data-testid="exercice-fin-select" className="h-11 bg-card"><SelectValue placeholder="Année" /></SelectTrigger>
                        <SelectContent>{YEARS.map((y) => <SelectItem key={y} value={String(y)} data-testid={`exercice-fin-${y}`}>{y}</SelectItem>)}</SelectContent>
                    </Select>
                </Field>
            </div>

            <Field id="notes" label="Contexte de la mission">
                <div className="flex items-start gap-2">
                    <Textarea id="notes" data-testid="notes-input" rows={5} placeholder="Origine de la demande, difficultés connues, attentes du client, délais…" className="bg-card resize-y" value={notes} onChange={(e) => setNotes(e.target.value)} />
                    <MicButton testId="notes-mic" onText={(t) => setNotes((v) => (v ? v + " " : "") + t)} />
                </div>
            </Field>

            {contexte && (
                <div data-testid="checklist-preview" className="space-y-2">
                    <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Documents attendus en dataroom</p>
                    <p className="text-xs text-muted-foreground">Cochez / décochez les pièces à exiger pour cette mission. La liste est pré-remplie selon le contexte et reste modifiable depuis la fiche dossier.</p>
                    <DocumentChecklistEditor value={documentsRequis} onChange={setDocumentsRequis} contexteAudit={contexte} idPrefix="mission-checklist" />
                </div>
            )}
        </FormSection>
    );
}
